import { css } from '@mui/material/styles';
export const buttonComponentOverrides = {
    MuiButtonBase: {
        defaultProps: {
            disableRipple: true,
            disableTouchRipple: true
        }
    },
    MuiButton: {
        defaultProps: {
            variant: 'secondary',
            size: 'medium'
        },
        variants: [
            {
                props: {
                    variant: 'primary'
                },
                style: ({ theme }) => css `
                    box-shadow: ${theme.tokens.FuelShadowXs}, ${theme.tokens.FuelShadowInsetButton}, rgba(0, 0, 0, 0.05) 0px 1px 0px 0px;

                    &, &:focus, &:focus-visible, &:disabled {
                        background-color: ${theme.tokens.FuelColorBackgroundActionPrimaryBase};
                    }

                    &, &:disabled {
                        color: ${theme.tokens.FuelColorTextActionPrimary};
                    }

                    &:hover:not(:disabled) {
                        background-color: ${theme.tokens.FuelColorBackgroundActionPrimaryHovered};
                    }

                    &:active:not(:disabled) {
                        background-color: ${theme.tokens.FuelColorBackgroundActionPrimaryPressed};
                    }

                    &:focus-visible {
                        box-shadow: ${theme.tokens.FuelShadowInsetButton}, ${theme.tokens.FuelShadowFocused};
                    }

                    &:disabled {
                        box-shadow: none;
                    }
                `
            },
            {
                props: {
                    variant: 'secondary'
                },
                style: ({ theme }) => css `
                    box-shadow: ${theme.tokens.FuelShadowXs}, rgba(0, 0, 0, 0.05) 0px 1px 0px 0px;
                    border: 1px solid ${theme.tokens.FuelColorBorderDark};
                    border-top-color: #bfbfbf;

                    &, &:focus, &:focus-visible, &:disabled {
                        background-color: ${theme.tokens.FuelColorBackgroundActionSecondaryBase};
                    }

                    &:hover, &:active {
                        border-color: ${theme.tokens.FuelColorBorderDark};
                    }

                    &, &:disabled {
                        color: ${theme.tokens.FuelColorTextActionSecondary};
                    }

                    &:hover:not(:disabled) {
                        background-color: ${theme.tokens.FuelColorBackgroundActionSecondaryHovered};
                    }

                    &:active:not(:disabled) {
                        background-color: ${theme.tokens.FuelColorBackgroundActionSecondaryPressed};
                    }

                    &:disabled {
                        border-color: ${theme.tokens.FuelColorBorderLight};
                        box-shadow: none;
                    }
                `
            },
            {
                props: {
                    variant: 'text'
                },
                style: ({ theme }) => css `
                    box-shadow: none;

                    &, &:disabled {
                        color: ${theme.tokens.FuelColorTextActionTertiary};
                    }

                    &:hover:not(:disabled) {
                        background-color: ${theme.tokens.FuelColorBackgroundActionTertiaryHovered};
                    }

                    &:active:not(:disabled) {
                        background-color: ${theme.tokens.FuelColorBackgroundActionTertiaryPressed};
                    }
                `
            },
            {
                props: {
                    variant: 'text',
                    size: 'small'
                },
                style: () => css `
                    padding-inline: 0.5625rem;
                `
            },
            {
                props: {
                    variant: 'text',
                    size: 'medium'
                },
                style: ({ theme }) => css `
                    padding-inline: ${theme.tokens.FuelSpacing3};
                `
            },
            {
                props: {
                    variant: 'text',
                    size: 'large'
                },
                style: () => css `
                    padding-inline: 0.9375rem;
                `
            },
            {
                props: {
                    variant: 'text-inline'
                },
                style: ({ theme }) => css `
                    white-space: inherit;
                    text-align: inherit;
                    text-decoration: underline;
                    border-radius: 0;
                    font-weight: inherit;
                    padding: 0;
                    vertical-align: baseline;
                    height: auto;

                    &, &:disabled {
                        color: ${theme.tokens.FuelColorTextActionTertiary};
                    }

                    &:hover {
                        color: ${theme.tokens.FuelColorTextLinkHovered};
                        text-decoration: underline;
                        box-shadow: none;
                    }
                `
            }
        ],
        styleOverrides: {
            root: ({ theme }) => css `
                transition: unset;
                min-width: auto;
                white-space: nowrap;
                display: inline-flex;
                align-items: center;
                font-family: ${theme.tokens.FuelFontFamilyBase};

                &:hover {
                    background-color: transparent;
                }

                &:focus {
                    background-color: transparent;
                    outline: none;
                }

                &:focus-visible {
                    background-color: transparent;
                    box-shadow: ${theme.tokens.FuelShadowFocused};
                }

                &:disabled {
                    background-color: transparent;
                    cursor: not-allowed;
                    pointer-events: auto;
                    opacity: .4;
                }
            `,
            sizeSmall: ({ theme }) => css `
                font-size: 0.8125rem;
                height: ${theme.tokens.FuelSpacing8};
                padding-inline: 0.75rem;
                padding-block: 0.4375rem;
            `,
            sizeMedium: ({ theme }) => css `
                font-size: ${theme.tokens.FuelFontSizeSm};
                height: 2.25rem;
                padding-inline: 1rem;
                padding-block: 0.5rem;
            `,
            sizeLarge: ({ theme }) => css `
                font-size: ${theme.tokens.FuelFontSizeBase};
                height: ${theme.tokens.FuelSpacing10};
                padding-inline: 1.25rem;
                padding-block: 0.5625rem;
            `,
            startIcon: ({ theme }) => css `
                margin-left: -${theme.tokens.FuelSpacing1};
                margin-right: ${theme.tokens.FuelSpacing1};
            `,
            endIcon: ({ theme }) => css `
                margin-left: ${theme.tokens.FuelSpacing1};
                margin-right: -${theme.tokens.FuelSpacing1};
            `
        }
    },
    MuiButtonGroup: {
        defaultProps: {
            disableRipple: true
        }
    }
};
